import { format, isValid, parse } from 'date-fns';

const ISO_FORMAT = 'yyyy-MM-dd';
const MASK_FORMAT = 'dd/MM/yyyy';

export const isoToDateMask = (iso: string): string => {
  if (!iso) return '';
  const date = parse(iso, ISO_FORMAT, new Date());
  if (!isValid(date)) return '';
  return format(date, MASK_FORMAT);
};

export const dateMaskToIso = (masked: string): string | null => {
  if (!masked) return null;
  const date = parse(masked, MASK_FORMAT, new Date());
  if (!isValid(date)) return null;
  return format(date, ISO_FORMAT);
};
